import React from 'react';

const SineWaveGraph = ({ p5, x, y, w, h, currentState, signalLockStrength, frequency, bandwidth, qFactor, signalStrength }) => {
  p5.stroke(0, 255, 0, 150);
  p5.noFill();
  
  // Draw background grid with finer lines
  p5.stroke(0, 255, 0, 15);
  const gridSizeX = 30;
  const gridSizeY = 20;
  
  // Vertical grid lines
  for (let i = 0; i <= w; i += gridSizeX) {
    const alpha = i % (gridSizeX * 4) === 0 ? 30 : 15;
    p5.stroke(0, 255, 0, alpha);
    p5.line(x + i, y, x + i, y + h);
  }
  
  // Horizontal grid lines
  for (let i = 0; i <= h; i += gridSizeY) {
    const alpha = i % (gridSizeY * 4) === 0 ? 30 : 15;
    p5.stroke(0, 255, 0, alpha);
    p5.line(x, y + i, x + w, y + i);
  }
  
  // Draw center axis with subtle glow
  p5.stroke(0, 255, 0, 40);
  p5.strokeWeight(2);
  p5.line(x, y + h/2, x + w, y + h/2);
  p5.strokeWeight(1);
  
  // Draw dynamic sine wave
  p5.stroke(0, 255, 0, 200);
  p5.beginShape();
  const baseAmplitude = h/4; // Reduced amplitude for cleaner look
  
  // Adjust parameters based on state
  let noiseIntensity, signalClarity;
  
  switch(currentState) {
    case 'SCANNING':
      noiseIntensity = 0.6;
      signalClarity = 0.1;
      break;
    case 'SIGNAL_FOUND':
      noiseIntensity = p5.lerp(0.6, 0.1, signalLockStrength);
      signalClarity = p5.lerp(0.1, 0.9, signalLockStrength);
      break;
    default:
      noiseIntensity = 0.1;
      signalClarity = 0.9;
      break;
  }
  
  const period = 20 + Math.log(frequency) * 5;
  const dynamicAmplitude = baseAmplitude * (0.4 + signalStrength/400.0) * (1 + qFactor/1000.0);
  
  for (let i = 0; i < w; i++) {
    const angle = (p5.frameCount * 0.08 + i) / period * p5.TWO_PI;
    const mainSignal = p5.sin(angle) * dynamicAmplitude * signalClarity;
    
    // Reduced harmonics for cleaner signal
    const harmonic1 = p5.sin(angle * 1.5) * (bandwidth * 0.05) * signalClarity;
    const harmonic2 = p5.sin(angle * 2.5) * (bandwidth * 0.025) * signalClarity;
    
    // Finer noise
    const noise1 = p5.noise(i * 0.05, p5.frameCount * 0.05) * 2 - 1;
    const noise2 = p5.noise(i * 0.1 + 1000, p5.frameCount * 0.025) * 2 - 1;
    const noiseSignal = (noise1 + noise2) * dynamicAmplitude * noiseIntensity * 0.5;
    
    let yOffset = mainSignal +
                harmonic1 * dynamicAmplitude * 0.2 +
                harmonic2 * dynamicAmplitude * 0.1 +
                noiseSignal;
    
    // Reduced jitter
    const jitter = p5.random(-2, 2) * noiseIntensity;
    yOffset += jitter;
    
    p5.vertex(x + i, y + h/2 + yOffset);
  }
  p5.endShape();
};

export default SineWaveGraph;